import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/service/apiServices';
import { AuthService } from 'src/app/service/auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  currentUser: any = {};
  client: any = {};
  locationSelected: any = 'Português';
  menuToogle: any = false;
  menuToogle_: any = false;

  constructor(
    private router: Router,
    public apiService: ApiService,
    private authService: AuthService,
  ) {
    this.authService.toogleMenu.subscribe((res: any) => {
      this.menuToogle = res;
    });
    this.authService.currentUser.subscribe((res: any) => {
      this.currentUser = res;
    });
  }

  ngOnInit(): void {
  }

  sair() {
    this.authService.logoutUser();
  }

  toogleMenu() {
    this.menuToogle_ = !this.menuToogle_;
    this.authService.setAtualizarMenu(this.menuToogle_)
  }


  toogleMenu2() {
    this.menuToogle_ = !this.menuToogle_;
    this.authService.setAtualizarMenu2(this.menuToogle_)
  }

  perfil() {
    this.router.navigate(['/profile']);
  }
}
